import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetStatusCategories } from 'src/app/asset/models/asset.model';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';
import { EventService } from 'src/app/core/services/http/event.service';
import { Events } from 'src/app/shared/constants/events.constant';
@Component({
  selector: 'app-asset-detail-with-backdrop',
  templateUrl: './asset-detail-with-backdrop.component.html',
  styleUrls: ['./asset-detail-with-backdrop.component.scss']
})
export class AssetDetailWithBackdropComponent implements OnInit {

  public shouldReturnToPreviousPage: boolean = false;
  public assetStatusCategoriesEnum: typeof AssetStatusCategories = AssetStatusCategories;
  constructor( private assetService: AssetService,
    private eventService: EventService,
  ){ 
    
    this.eventService.events.subscribe((event) => {
      const relevantEvents = [
        Events.DeleteAssetEvent,
        Events.ApproveAssetEvent,
        Events.SentToTenantAssetEvent,
        Events.EditAssetEvent
      ];
    
      if (relevantEvents.includes(event)) {
        this.goBack();
      }
    });
  }
  
  @Input() selectedAssetId : string;
  @Input() assetStatus : string;
  @Output() closeAssetDetails = new EventEmitter<boolean>();
  ngOnInit(): void {

  }
  public goBack() {
      this.closeAssetDetails.emit(true);
  }
}
